import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import messages from "../../../../assets/i18n";
import { ButtonStandard, FooterActions } from '../../../../components';
import Header from "../../../../components/Header/Header";
import './MultipleProfile.scss';
import getEnvParam from "../../../../utils/getEnvParam";

function MultipleProfile (props) {

    const permissions = props.permissions;
    const lang = useSelector(state => state.language.name);
    const chapa = useSelector(state => state.authentication.chapa);

	const logout = () => {
		window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'logout';
	}

    const ButtonGroupLeft = () => {
		return <>
			<ButtonStandard
				id="cd_list"
				text={messages[lang].back}
				textClass="text-3"
				className="btn btn-primary px-4 py-2 btn-light"
				icon="icon-bi-x text-3"
				onClick={logout}
			/>
		</>
	}

	return (
		<div className="mainPage">
            <Header showTags={false}/>
			<div></div>
			<Container className="pt-3 justify-content-start">
				<Row className="justify-content-between">
					<Col className="d-flex align-items-center justify-content-start">
						<span className="text-3 font-weight-bold header-main pl-2">{messages[lang].multipleProfileTitle}</span>
					</Col>
				</Row>
			</Container>

                <Container className="pt-3 justify-content-start">
                    
            <div className="borda">
					{messages[lang].multipleProfileMessage1} <b>{chapa}</b>
                    <br/>
                    <br/>

                    <ul>
                    {permissions.map((value, index) => (
                        <li>{value}</li>
                    ))}
                    </ul>

                    <br/>
                    {messages[lang].multipleProfileMessage2}
            </div>
                </Container>
                <FooterActions ButtonGroupLeft={ButtonGroupLeft} />
		</div>
	);
}

export default MultipleProfile;